import { api } from './client'

// ---------- tipuri — oglindesc DTO-urile din Cipral.Application/Organization/WorkPointModels.cs ----------

export interface WorkPointListItem { id: string; code: string; name: string; city: string | null; isDefault: boolean; isActive: boolean }

export interface WorkPointDetail {
  id: string
  code: string
  name: string
  address: string | null
  city: string | null
  isDefault: boolean
  isActive: boolean
}

export type SaveWorkPointPayload = Omit<WorkPointDetail, 'id' | 'isActive'>

export const listWorkPoints = () => api.get<WorkPointListItem[]>('/administrare/puncte-lucru').then((r) => r.data)
export const getWorkPoint = (id: string) => api.get<WorkPointDetail>(`/administrare/puncte-lucru/${id}`).then((r) => r.data)

export const createWorkPoint = (payload: SaveWorkPointPayload) =>
  api.post<{ id: string }>('/administrare/puncte-lucru', payload).then((r) => r.data)

export const updateWorkPoint = (id: string, payload: SaveWorkPointPayload) =>
  api.put(`/administrare/puncte-lucru/${id}`, payload)

export const deactivateWorkPoint = (id: string) => api.post(`/administrare/puncte-lucru/${id}/deactivate`)
export const reactivateWorkPoint = (id: string) => api.post(`/administrare/puncte-lucru/${id}/reactivate`)
